import { DatasetInfo } from "api/model/dataset/DatasetInfo"
import axios from "axios"
import { IQueryOptions, useQueryWrapper } from "./api-hooks-common"

const API_URL = `${window.contextRoot}/api-proxy/easas-mdm/server`
const prefix = "mdm-server"

const enum MdmQueryKey {
  DATASETS_BY_DEVICE = `${prefix}-device-datasets`,
}

// eslint-disable-next-line import/prefer-default-export
export const useGetDatasetsByDevice = (deviceId: string, options?: IQueryOptions) =>
  useQueryWrapper(
    [MdmQueryKey.DATASETS_BY_DEVICE, deviceId],
    () => axios.get<DatasetInfo[]>(`${API_URL}/device-datasets/${deviceId}`),
    null,
    options
  )